import { Component, OnInit, Input, inject } from '@angular/core';
import { AbstractOrderApiService } from 'src/app/core/services/abstract/abstract-order-api-service';
import { T22EntityItemDTO } from 'src/app/store/order/model';

@Component({
  selector: 'app-attr-dictionary',
  templateUrl: './attr-dictionary.component.html',
  styleUrls: ['./attr-dictionary.component.scss'],
  standalone: false,
})
export class AttrDictionaryComponent implements OnInit {
  private orderApiService = inject(AbstractOrderApiService);

  @Input() propertyId: string;
  @Input() dictionaryId: number;
  @Input() caption: string;
  @Input() value: string;
  @Input() mandatory: boolean;
  @Input() isDisabled: boolean;
  @Input() valueKey: boolean;

  dataSource: T22EntityItemDTO[] = [];

  ngOnInit(): void {
    this.orderApiService.getDictionary(this.dictionaryId).subscribe(x => {
      this.dataSource = x.isSucceeded ? x.result : [];
    });
  }
}
